var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchSubmit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.211 20.411a10.148 10.148 0 006.293-2.18L23.27 25 25 23.269 18.234 16.5a10.2 10.2 0 10-8.024 3.911zm0-17.962a7.755 7.755 0 11-5.483 2.272 7.753 7.753 0 015.483-2.272z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "0c7749b88e5b97c795ed5e8cdb231f0f.svg";
export { SvgSearchSubmit as ReactComponent };